// src/pages/HomePage.js
import React, { useState, useEffect  } from 'react'
import { Link } from "react-router-dom";
import reactLogo from '../assets/react.svg'
import viteLogo from '/vite.svg'
import ImageSlider from '../components/ImageSlider';
import axios from "axios";
import PropTypes from "prop-types";
import { AnimatePresence, motion } from "framer-motion";
import {
  Bell,
  Calendar,
  ArrowRight,
  FileText,
  Download,
  GraduationCap,
  ChevronLeft,
  ChevronRight,
  ArrowUpRight,
  CalendarDays,
  ChevronDown,
  BookOpen,
  BadgeCheck,
  CheckCircle2,
} from "lucide-react";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.08 },
  },
};

const item = {
  hidden: { opacity: 0, y: 15 },
  show: { opacity: 1, y: 0 },
};
function HomePage({ pageTitle }) {
	const [notice, setNotice] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [activeTab, setActiveTab] = useState("notices");
	const [indexs, setIndexs] = useState(0);
	const [news, setNews] = useState([]);
	const [videos, setvideos] = useState([]);
	const [selectedVideo, setSelectedVideo] = useState(null);
	const [autoPlay, setAutoPlay] = useState(false);
	const [events, setEvents] = useState([]);
	const [openId, setOpenId] = useState(null);
	const VISIBLE_NEWS = 4;
	const tabs = [
		{ id: "notices", label: "Recent Notices" },
		{ id: "events", label: "Events" },		
	];
	const months = [
	  'January', 'February', 'March', 'April', 'May', 'June',
	  'July', 'August', 'September', 'October', 'November', 'December'
	];
	const programs = [
	  {
		title: "Bachelor of Computer Science and Engineering",
		image: "/assets/img/cse.jpg",
		link: "/program/cse",
	  },
	  {
		title: "Bachelor of Business Administration",
		image: "assets/img/bba.jpg",
		link: "/program/bba",
	  },
	  {
		title: "Bachelor of Social Science in Governance and Development Studies",
		image: "/assets/img/gds.jpg",
		link: "/program/gds",
	  },
	  {
		title: "Bachelor of Arts in English",
		image: "/assets/img/ell.jpg",
		link: "/program/english",
	  },
	  {
		title: "Bachelor of Hospitality and Tourism Management",
		image: "/assets/images/htm.jpeg",
		link: "/program/htm",
	  },
	  {
		title: "Master of Business Administration",
		image: "/assets/img/mba.jpg",
		link: "/program/mba",
	  },
	];
	
	const faqs = [
	  {
		id: 1,
		question: "What programs does Bandarban University offer?",
		answer:
		  "Bandarban University offers undergraduate and graduate programs across multiple disciplines including science, arts, business, and technology.",
	  },
	  {
		id: 2,
		question: "How can I apply for admission?",
		answer:
		  "You can apply online through our admission portal or visit the university admission office for in-person guidance.",
	  },
	  {
		id: 3,
		question: "Does the university provide accommodation?",
		answer:
		  "Yes, the university provides on-campus hostel facilities for both male and female students.",
	  },
	  {
		id: 4,
		question: "Where is Bandarban University located?",
		answer:
		  "The university is located in the scenic hills of Bandarban, offering a peaceful and inspiring learning environment.",
	  },
	  {
		id: 5,
		question: "What are the schools in Bandarban University?",
		answer:
		  "There are three (3) schools in Bandarban University. They are School of Arts, Social Science and Law, School of Business Administration and School of Science , Engineering and Technology.",
	  },
	  {
		id: 6,
		question: "Which bachelor programs are offered by Bandarban University? ",
		answer:
		  "Bandarban University offers the following bachelor programs: Bachelor of Arts in English, Bachelor of Social Science in Governance and Development Studies(GDS), Bachelor of Business Administration(BBA), Bachelor of Computer Science and Engineering(CSE).",
	  },
	  {
		id: 7,
		question: "Admission Requirements in Bachelor Program? ",
		answer:
		  "Combined GPA of 5.00 in S.S.C and H.S.C with minimum 2.5 in each or total GPA of 6.00 with minimum GPA of 2.00 either in S.S.C or in H.S.C GCE O- Level in minimum 5 subject with a GPA 2.50 and GCE A- Level in 2 subject with a minimum GPA 2.00. Engineering students must have maths and physics in their H.S.C with at least B grade",
	  },
	  {
		id: 8,
		question: "Admission Requirements in Master Programs ? ",
		answer:
		  "Anyone having GPA of minimum 2.50 can seek admission to master program of the University.",
	  },
	  {
		id: 9,
		question: "Which master programs are offered by Bandarban University?? ",
		answer:
		  "Bandarban University offers the following master programs: Master of Business Administration.",
	  },
	];

	
	function MonthDisplay(props) {
		const myDate = new Date(props); // Example date
		const monthIndex = myDate.getMonth();
		const monthName = months[monthIndex];

		return monthName;
	}
	const handlePost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
				department_id:'0',
			});
			const response = await api.post("/recent-notice", payload);
			
			
			// Loop data (array)
			setNotice(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	
	const newsPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
				department_id:'0',
			});
			const response = await api.post("/recent-news", payload);
			
			
			// Loop data (array)
			setNews(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	
	const videoPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
				department_id:'0',
			});
			const response = await api.post("/recent-videos", payload);
			
			const data = response.data;
			// Loop data (array)
			setvideos(response.data || []);
			
			if (data.length > 0) {
			  setSelectedVideo(data[0]);
			  setAutoPlay(false);
			}
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	
	const eventsPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
				department_id:'0',
			});
			const response = await api.post("/recent-events", payload);
			
			
			// Loop data (array)
			setEvents(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	
	useEffect(() => {
		handlePost();
		newsPost();
		videoPost();
		eventsPost();
	}, []);
	
	
	
	useEffect(() => {
	  if (news.length <= VISIBLE_NEWS) return;

	  const interval = setInterval(() => {
		setIndexs((prev) => (prev + 1) % news.length);
	  }, 5000);

	  return () => clearInterval(interval);
	}, [news.length]);

	// Next
	const handleNext = () => {
	  if (news.length === 0) return;

	  setIndexs((prev) => (prev + 1) % news.length);
	};

	// Previous
	const handlePrev = () => {
	  if (news.length === 0) return;

	  setIndexs((prev) => (prev - 1 + news.length) % news.length);
	};

	// Get 4 current news items
	const getCurrentNews = () => {
	  if (news.length === 0) return [];

	  const visibleCount = Math.min(VISIBLE_NEWS, news.length);

	  return Array.from({ length: visibleCount }, (_, i) => {
		return news[(indexs + i) % news.length];
	  });
	};

	const currentNews = getCurrentNews();

	const handleVideoClick = (video) => {
		setSelectedVideo(video);
		setAutoPlay(true); // enable autoplay only when clicked
	};
	
	useEffect(() => {
		document.title = "Bandarban University"; // Sets the document title
	}, [pageTitle]);
	
	const toggleFAQ = (id) => {
		setOpenId(openId === id ? null : id);
	};
	return (
		<>
			<ImageSlider />	
			
			{/* ================= NOTICES, EVENTS & ADMISSION ================= */}
			<section className="relative overflow-hidden bg-gradient-to-b from-emerald-50/70 via-white to-green-50/50 py-16 md:py-24">

			  {/* Background decorations */}
			  <div className="pointer-events-none absolute inset-0 overflow-hidden">
				<motion.div
				  animate={{ x: [0, 25, 0], y: [0, -20, 0] }}
				  transition={{ duration: 12, repeat: Infinity }}
				  className="absolute -left-24 top-20 h-72 w-72 rounded-full bg-green-200/30 blur-3xl"
				/>
				<motion.div
				  animate={{ x: [0, -20, 0], y: [0, 20, 0] }}
				  transition={{ duration: 14, repeat: Infinity }}
				  className="absolute -right-24 bottom-10 h-80 w-80 rounded-full bg-emerald-200/30 blur-3xl"
				/>
			  </div>

			  <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

				{/* Section heading */}
				<motion.div
				  initial={{ opacity: 0, y: 25 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  viewport={{ once: true }}
				  transition={{ duration: 0.6 }}
				  className="mb-12 text-center"
				>
				  <span className="inline-flex items-center gap-2 rounded-full border border-green-200 bg-white px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-green-800 shadow-sm">
					<span className="h-2 w-2 animate-pulse rounded-full bg-green-500" />
					University Updates
				  </span>

				  <h2 className="mt-5 text-3xl font-black tracking-tight text-gray-900 sm:text-4xl lg:text-5xl">
					Stay Connected With
					<span className="mt-1 block bg-gradient-to-r from-green-700 via-emerald-600 to-teal-500 bg-clip-text text-transparent">
					  Campus Life
					</span>
				  </h2>

				  <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-gray-600 sm:text-base">
					Discover university announcements, upcoming events, and admission
					opportunities at Bandarban University.
				  </p>
				</motion.div>

				<motion.div
				  variants={container}
				  initial="hidden"
				  whileInView="show"
				  viewport={{ once: true, amount: 0.1 }}
				  className="grid min-w-0 grid-cols-1 items-start gap-7 lg:grid-cols-3"
				>

				  {/* LEFT PANEL: NOTICES & EVENTS */}
				  <motion.div
					variants={item}
					className="min-w-0 overflow-hidden rounded-3xl border border-white bg-white/90 p-4 shadow-[0_15px_60px_rgba(15,80,45,0.09)] backdrop-blur-xl sm:p-6 lg:col-span-2"
				  >

					{/* Panel heading */}
					<div className="mb-5 flex flex-wrap items-center justify-between gap-3">
					  <div>
						<p className="text-xs font-bold uppercase tracking-[0.15em] text-green-700">
						  What's happening
						</p>
						<h3 className="mt-1 text-xl font-extrabold text-gray-900 sm:text-2xl">
						  News & Activities
						</h3>
					  </div>

					  <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-green-600 to-emerald-500 text-white shadow-lg shadow-green-200">
						<Bell size={21} />
					  </div>
					</div>

					{/* Animated tabs */}
					<div className="flex gap-2 border-b border-gray-100 pb-4">
					  {tabs.map((tab) => (
						<button
						  key={tab.id}
						  type="button"
						  onClick={() => setActiveTab(tab.id)}
						  className={`relative inline-flex items-center gap-2 rounded-xl px-4 py-3 text-sm font-bold transition-all duration-300 ${
							activeTab === tab.id
							  ? "bg-green-50 text-green-800"
							  : "text-gray-500 hover:bg-gray-50 hover:text-green-700"
						  }`}
						>
						  {tab.id === "notices" && <Bell size={17} />}
						  {tab.id === "events" && <Calendar size={17} />}

						  {tab.label}

						  {activeTab === tab.id && (
							<motion.span
							  layoutId="notice-event-tab"
							  className="absolute inset-x-3 -bottom-[17px] h-[3px] rounded-full bg-gradient-to-r from-green-600 to-emerald-400"
							  transition={{
								type: "spring",
								stiffness: 350,
								damping: 30,
							  }}
							/>
						  )}
						</button>
					  ))}
					</div>

					{/* NOTICES */}
					<AnimatePresence mode="wait">
					  {activeTab === "notices" && (
						<motion.div
						  key="notices"
						  initial={{ opacity: 0, x: -12 }}
						  animate={{ opacity: 1, x: 0 }}
						  exit={{ opacity: 0, x: 12 }}
						  transition={{ duration: 0.25 }}
						  className="mt-5 space-y-3"
						>
						  {notice.slice(0, 6).map((info, index) => {
							const dateParts = (info.date || "").split("-");
							const day = dateParts[2] || "--";

							return (
							  <motion.div
								key={info.id ?? index}
								initial={{ opacity: 0, y: 12 }}
								animate={{ opacity: 1, y: 0 }}
								transition={{
								  duration: 0.35,
								  delay: index * 0.06,
								}}
								whileHover={{ x: 4 }}
								className="group flex min-w-0 items-center gap-3 rounded-2xl border border-gray-100 bg-white p-3 transition-all duration-300 hover:border-green-200 hover:bg-green-50/50 hover:shadow-md sm:gap-4 sm:p-4"
							  >
								{/* Date block */}
								<div className="flex h-[66px] w-[62px] shrink-0 flex-col items-center justify-center rounded-xl bg-gradient-to-br from-green-100 to-emerald-50 text-green-800 ring-1 ring-green-100 transition-colors group-hover:from-green-700 group-hover:to-emerald-600 group-hover:text-white">
								  <span className="text-xl font-black leading-none">
									{day}
								  </span>
								  <span className="mt-1 text-[10px] font-bold uppercase tracking-wider">
									{MonthDisplay(info.date)}
								  </span>
								</div>

								{/* Notice content */}
								<div className="min-w-0 flex-1">
								  <div className="mb-1 flex items-center gap-2">
									<span className="h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-500" />
									<span className="text-[10px] font-bold uppercase tracking-wider text-green-700">
									  University Notice
									</span>
								  </div>

								  <h4 className="line-clamp-2 text-sm font-bold leading-6 text-gray-800 transition-colors group-hover:text-green-800 sm:text-[15px]">
									{info.head_line}
								  </h4>
								</div>

								<Link
								  to={`/notice/${info.id}`}
								  aria-label={`Read notice: ${info.head_line}`}
								  className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-50 text-green-700 transition-all duration-300 group-hover:bg-green-700 group-hover:text-white"
								>
								  <ArrowRight size={17} />
								</Link>
							  </motion.div>
							);
						  })}

						  {notice.length === 0 && (
							<div className="rounded-2xl border border-dashed border-gray-200 p-10 text-center">
							  <Bell className="mx-auto text-gray-300" size={30} />
							  <p className="mt-3 text-sm text-gray-500">
								No notices available at the moment.
							  </p>
							</div>
						  )}

						  <div className="pt-2">
							<Link
							  to="/all-notice"
							  className="group inline-flex items-center gap-2 rounded-xl border border-green-200 px-4 py-2.5 text-sm font-bold text-green-800 transition-all hover:border-green-700 hover:bg-green-700 hover:text-white"
							>
							  View All Notices
							  <ArrowRight
								size={16}
								className="transition-transform group-hover:translate-x-1"
							  />
							</Link>
						  </div>
						</motion.div>
					  )}

					  {/* EVENTS */}
					  {activeTab === "events" && (
						<motion.div
						  key="events"
						  initial={{ opacity: 0, x: 12 }}
						  animate={{ opacity: 1, x: 0 }}
						  exit={{ opacity: 0, x: -12 }}
						  transition={{ duration: 0.25 }}
						  className="mt-5"
						>
						  <div className="grid min-w-0 gap-5 sm:grid-cols-2">
							{events.slice(0, 4).map((event, index) => (
							  <motion.div
								key={event.id}
								initial={{ opacity: 0, y: 18 }}
								animate={{ opacity: 1, y: 0 }}
								transition={{
								  duration: 0.4,
								  delay: index * 0.08,
								}}
								whileHover={{ y: -5 }}
								className="group min-w-0 overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition-shadow hover:shadow-xl"
							  >
								<div className="relative h-44 overflow-hidden bg-green-50">
								  <img
									src={`${import.meta.env.VITE_API_SOURCE_URL}${event.images}`}
									alt={event.name}
									loading="lazy"
									className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
								  />

								  <div className="absolute inset-0 bg-gradient-to-t from-green-950/75 via-transparent to-transparent" />

								  <span className="absolute bottom-3 left-3 inline-flex items-center gap-2 rounded-lg border border-white/20 bg-white/15 px-3 py-1.5 text-xs font-semibold text-white backdrop-blur-md">
									<Calendar size={14} />
									University Event
								  </span>
								</div>

								<div className="p-4">
								  <h4 className="line-clamp-2 text-base font-extrabold leading-6 text-gray-900 transition-colors group-hover:text-green-800">
									{event.name}
								  </h4>

								  <div className="mt-3 flex items-start gap-2 text-xs leading-5 text-gray-500">
									<Calendar
									  size={15}
									  className="mt-0.5 shrink-0 text-green-700"
									/>
									<span>
									  {event.start_date} → {event.end_date}
									</span>
								  </div>
								</div>
							  </motion.div>
							))}
						  </div>

						  {events.length === 0 && (
							<div className="rounded-2xl border border-dashed border-gray-200 p-10 text-center">
							  <Calendar className="mx-auto text-gray-300" size={30} />
							  <p className="mt-3 text-sm text-gray-500">
								No upcoming events available.
							  </p>
							</div>
						  )}

						  <div className="mt-5">
							<Link
							  to="/all-events"
							  className="group inline-flex items-center gap-2 rounded-xl border border-green-200 px-4 py-2.5 text-sm font-bold text-green-800 transition-all hover:bg-green-700 hover:text-white"
							>
							  Explore All Events
							  <ArrowRight
								size={16}
								className="transition-transform group-hover:translate-x-1"
							  />
							</Link>
						  </div>
						</motion.div>
					  )}
					</AnimatePresence>
				  </motion.div>

				  {/* RIGHT PANEL: ADMISSION */}
				  <motion.div
					variants={item}
					className="group relative min-w-0 overflow-hidden rounded-3xl bg-gradient-to-br from-green-800 via-green-700 to-emerald-500 p-5 text-white shadow-[0_20px_60px_rgba(22,101,52,0.22)] sm:p-7"
				  >
					{/* Decorative elements */}
					<motion.div
					  animate={{ rotate: 360 }}
					  transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
					  className="pointer-events-none absolute -right-16 -top-16 h-52 w-52 rounded-full border border-white/10"
					/>
					<div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-white/10 blur-3xl" />
					<div className="pointer-events-none absolute -bottom-16 -left-10 h-40 w-40 rounded-full bg-emerald-300/20 blur-3xl" />

					<div className="relative">
					  <div className="flex items-center justify-between gap-3">
						<span className="rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.16em] text-green-50">
						  Join Our University
						</span>

						<div className="flex h-11 w-11 items-center justify-center rounded-2xl border border-white/20 bg-white/10">
						  <GraduationCap size={23} />
						</div>
					  </div>

					  <h2 className="mt-5 text-2xl font-black leading-tight sm:text-3xl">
						Begin Your
						<span className="block text-emerald-200">Journey Today.</span>
					  </h2>

					  <p className="mt-3 text-sm leading-6 text-green-50/85">
						Take the next step toward your academic and professional goals.
					  </p>

					  <Link
						to="/apply-online"
						className="group/apply mt-5 flex w-full items-center justify-center gap-2 rounded-xl bg-white px-4 py-3.5 text-sm font-extrabold text-green-900 shadow-lg transition-all duration-300 hover:-translate-y-1 hover:bg-emerald-50"
					  >
						Apply Online Now
						<ArrowRight
						  size={17}
						  className="transition-transform group-hover/apply:translate-x-1"
						/>
					  </Link>

					  <div className="my-6 h-px bg-white/20" />

					  <h3 className="mb-3 flex items-center gap-2 text-sm font-bold text-white">
						<FileText size={17} />
						Admission Resources
					  </h3>

					  <div className="space-y-2">
						{[
						  {
							label: "Admission Advertisement",
							icon: FileText,
							link: "/admission-advertisements",
						  },
						  {
							label: "Admission Requirements",
							icon: BadgeCheck,
							link: "/admission-requirements",
						  },
						  {
							label: "Admission Instructions",
							icon: BookOpen,
							link: "/admission-instruction",
						  },
						  {
							label: "Download Admission Form",
							icon: Download,
							link: "/admission-form",
						  },
						  {
							label: "Download Admit Card",
							icon: Download,
							link: "/admit-card",
						  },
						  {
							label: "Download Offer Letter",
							icon: FileText,
							link: "/offer-letter",
						  },
						].map((resource, index) => {
						  const Icon = resource.icon;

						  return (
							<motion.div
							  key={resource.link}
							  initial={{ opacity: 0, x: 12 }}
							  whileInView={{ opacity: 1, x: 0 }}
							  viewport={{ once: true }}
							  transition={{ delay: index * 0.06 }}
							  whileHover={{ x: 4 }}
							>
							  <Link
								to={resource.link}
								className="flex min-w-0 items-center gap-3 rounded-xl border border-white/10 bg-white/[0.08] px-3 py-3 transition-all duration-300 hover:border-white/30 hover:bg-white/[0.18]"
							  >
								<span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/10 text-emerald-100">
								  <Icon size={17} />
								</span>

								<span className="min-w-0 flex-1 text-sm font-medium leading-5 text-white">
								  {resource.label}
								</span>

								<ArrowRight
								  size={15}
								  className="shrink-0 text-emerald-200"
								/>
							  </Link>
							</motion.div>
						  );
						})}
					  </div>

					  <div className="mt-5 flex items-start gap-3 rounded-xl border border-white/15 bg-black/10 p-3.5">
						<CheckCircle2
						  size={19}
						  className="mt-0.5 shrink-0 text-emerald-200"
						/>
						<p className="text-xs leading-5 text-green-50/85">
						  Check admission requirements and instructions before submitting
						  your application.
						</p>
					  </div>
					</div>
				  </motion.div>
				</motion.div>
			  </div>
			</section>


			{/* ================= OUR ACADEMIC PROGRAMS ================= */}
			<section className="relative overflow-hidden bg-white py-16 md:py-24">

			  {/* Background decoration */}
			  <div className="pointer-events-none absolute inset-0">
				<div className="absolute left-0 top-20 h-64 w-64 rounded-full bg-green-100/50 blur-3xl" />
				<div className="absolute bottom-0 right-0 h-72 w-72 rounded-full bg-emerald-100/50 blur-3xl" />

				<div
				  className="absolute inset-0 opacity-[0.035]"
				  style={{
					backgroundImage:
					  "radial-gradient(#166534 1px, transparent 1px)",
					backgroundSize: "24px 24px",
				  }}
				/>
			  </div>

			  <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

				{/* Heading */}
				<motion.div
				  initial={{ opacity: 0, y: 25 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  transition={{ duration: 0.65 }}
				  viewport={{ once: true }}
				  className="mx-auto mb-12 max-w-3xl text-center md:mb-16"
				>
				  <span className="inline-flex items-center gap-2 rounded-full border border-green-200 bg-green-50 px-4 py-2 text-xs font-bold uppercase tracking-[0.17em] text-green-800">
					<GraduationCap size={16} />
					Discover Your Potential
				  </span>

				  <h2 className="mt-5 text-3xl font-black leading-tight tracking-tight text-gray-900 sm:text-4xl lg:text-5xl">
					Our Academic
					<span className="ml-2 bg-gradient-to-r from-green-700 to-emerald-500 bg-clip-text text-transparent">
					  Programs
					</span>
				  </h2>

				  <div className="mx-auto mt-5 flex items-center justify-center gap-2">
					<span className="h-1 w-10 rounded-full bg-green-300" />
					<span className="h-1.5 w-16 rounded-full bg-gradient-to-r from-green-600 to-emerald-400" />
					<span className="h-1 w-10 rounded-full bg-green-300" />
				  </div>

				  <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-gray-600 sm:text-base">
					Explore academic programs designed to build knowledge, develop
					professional skills, and prepare you for the opportunities of tomorrow.
				  </p>
				</motion.div>

				{/* Program cards */}
				<motion.div
				  variants={container}
				  initial="hidden"
				  whileInView="show"
				  viewport={{ once: true, amount: 0.08 }}
				  className="grid min-w-0 grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
				>
				  {programs.map((program, index) => (
					<motion.article
					  key={program.id ?? program.link ?? index}
					  variants={item}
					  whileHover={{ y: -8 }}
					  className="group relative flex min-w-0 flex-col overflow-hidden rounded-3xl border border-gray-100 bg-white shadow-[0_8px_35px_rgba(0,0,0,0.055)] transition-all duration-500 hover:border-green-200 hover:shadow-[0_22px_55px_rgba(22,101,52,0.14)]"
					>
					  {/* Image */}
					  <div className="relative h-56 overflow-hidden bg-green-50 sm:h-60">
						<motion.img
						  src={program.image}
						  alt={program.title}
						  loading="lazy"
						  className="h-full w-full object-cover"
						  whileHover={{ scale: 1.1 }}
						  transition={{ duration: 0.7, ease: "easeOut" }}
						/>

						{/* Overlay */}
						<div className="absolute inset-0 bg-gradient-to-t from-green-950/85 via-green-950/15 to-transparent opacity-90 transition-opacity duration-300 group-hover:opacity-100" />

						{/* Animated accent */}
						<div className="absolute inset-x-0 bottom-0 h-1 origin-left scale-x-0 bg-gradient-to-r from-emerald-300 to-green-400 transition-transform duration-500 group-hover:scale-x-100" />

						{/* Tag */}
						<span className="absolute left-4 top-4 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/15 px-3 py-1.5 text-xs font-bold text-white shadow-lg backdrop-blur-md">
						  <GraduationCap size={14} />
						  Academic Program
						</span>

						{/* Title overlay */}
						<div className="absolute inset-x-5 bottom-5">
						  <span className="text-xs font-semibold uppercase tracking-[0.16em] text-emerald-200">
							Bandarban University
						  </span>

						  <h3 className="mt-2 line-clamp-2 text-xl font-black leading-7 text-white sm:text-2xl">
							{program.title}
						  </h3>
						</div>
					  </div>

					  {/* Card body */}
					  <div className="flex flex-1 flex-col p-5 sm:p-6">
						<p className="line-clamp-3 flex-1 text-sm leading-7 text-gray-600">
						  {program.description ||
							`Explore the ${program.title} program at Bandarban University and discover opportunities for academic growth and professional development.`}
						</p>

						<div className="mt-5 flex items-center justify-between gap-3 border-t border-gray-100 pt-5">
						  <div className="flex items-center gap-2 text-xs font-semibold text-gray-500">
							<span className="flex h-8 w-8 items-center justify-center rounded-xl bg-green-50 text-green-800 transition-colors group-hover:bg-green-700 group-hover:text-white">
							  <BookOpen size={16} />
							</span>
							Explore the program
						  </div>

						  <Link
							to={program.link}
							className="group/button inline-flex shrink-0 items-center gap-2 rounded-xl bg-gradient-to-r from-green-700 to-emerald-600 px-4 py-3 text-sm font-bold text-white shadow-md shadow-green-800/10 transition-all duration-300 hover:shadow-lg hover:shadow-green-800/20"
						  >
							Details
							<ArrowRight
							  size={16}
							  className="transition-transform duration-300 group-hover/button:translate-x-1"
							/>
						  </Link>
						</div>
					  </div>

					  {/* Subtle hover glow */}
					  <div className="pointer-events-none absolute -right-12 -top-12 h-32 w-32 rounded-full bg-emerald-300/20 opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-100" />
					</motion.article>
				  ))}
				</motion.div>

				{/* Bottom CTA */}
				<motion.div
				  initial={{ opacity: 0, y: 20 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  viewport={{ once: true }}
				  transition={{ duration: 0.6 }}
				  className="relative mt-12 overflow-hidden rounded-3xl bg-gradient-to-r from-green-950 via-green-800 to-emerald-700 p-6 text-white shadow-xl sm:p-8 lg:mt-16 lg:p-10"
				>
				  <div className="pointer-events-none absolute -right-10 -top-24 h-64 w-64 rounded-full bg-emerald-300/15 blur-3xl" />

				  <div className="relative flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
					<div className="max-w-2xl">
					  <span className="text-xs font-bold uppercase tracking-[0.17em] text-emerald-200">
						Your Future Starts Here
					  </span>

					  <h3 className="mt-3 text-2xl font-black sm:text-3xl">
						Ready to Begin Your Journey?
					  </h3>

					  <p className="mt-3 text-sm leading-7 text-green-50/80 sm:text-base">
						Take the next step and explore the admission opportunities
						available at Bandarban University.
					  </p>
					</div>

					<Link
					  to="/apply-online"
					  className="group inline-flex shrink-0 items-center gap-3 rounded-xl bg-white px-6 py-4 font-extrabold text-green-900 shadow-lg transition-all duration-300 hover:-translate-y-1 hover:bg-emerald-50 hover:shadow-xl"
					>
					  Apply for Admission
					  <ArrowRight
						size={19}
						className="transition-transform group-hover:translate-x-1"
					  />
					</Link>
				  </div>
				</motion.div>
			  </div>
			</section>

			<section className="w-full bg-gradient-to-r from-green-50 to-white py-16 px-6 md:px-20">
				<AnimatePresence>
				  <motion.div 
					initial={{ opacity: 0, y: -30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6 }}
					viewport={{ once: true }}
					className="max-w-7xl mx-auto grid md:grid-cols-2 gap-5 items-center">
					
					{/* Left Side - Image */}
					<div className="relative">
					  <img
						src="assets/img/about-bu.png"
						alt="Bandarban University"
						className="rounded-2xl shadow-lg w-full object-cover h-full"
					  />
					  <div className="absolute -bottom-5 -left-5 bg-green-500 text-white text-sm px-4 py-2 rounded-lg shadow-md">
						Since 2019
					  </div>
					</div>

					{/* Right Side - Content */}
					<div className="space-y-6">
					  <h2 className="text-3xl md:text-4xl font-bold text-green-800">
						First Public-Private Partnership (PPP) University in Bangladesh
					  </h2>
					  <p align="justify" className="text-gray-700 leading-relaxed">
						Bandarban University is the first Public-Private Partnership (PPP) university in Bangladesh. It is approved by the Government of Bangladesh and the University Grants Commission (UGC). Established in the lush greenery of Bandarban Hill District, the university provides a serene, and ideal environment for learning and academic excellence. Notably, students from 12 different ethnic communities study here, making it a unique hub of diversity, inclusion, and cultural harmony.
						<br/>
						Bandarban University Campus is surrounded by hills and nature, creating a peaceful and inspiring atmosphere for students and faculty members alike. The idea of establishing a university in Bandarban emerged from a long-standing vision to expand higher education opportunities in the Chattogram Hill Tracts region. With strong institutional initiatives and collaboration, this vision gradually turned into reality.

					  </p>
					  <Link to="/about" className="px-6 py-3 bg-green-600 text-white rounded-xl shadow-md hover:bg-green-700 transition">
						Details About Us
					  </Link>
					</div>
				  </motion.div>
				</AnimatePresence>
			</section>		
			
			<section className="relative w-full overflow-hidden bg-gradient-to-b from-white via-green-50/50 to-white py-20 px-4 sm:px-6 lg:px-12">

			  {/* Background Decorations */}
			  <div className="pointer-events-none absolute inset-0 overflow-hidden">
				<div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-green-200/30 blur-3xl" />
				<div className="absolute top-1/2 -right-24 h-80 w-80 rounded-full bg-emerald-200/30 blur-3xl" />
			  </div>

			  <div className="relative mx-auto max-w-7xl">

				{/* Section Header */}
				<motion.div
				  initial={{ opacity: 0, y: 30 }}
				  whileInView={{ opacity: 1, y: 0 }}
				  viewport={{ once: true, amount: 0.3 }}
				  transition={{ duration: 0.7 }}
				  className="mb-12 text-center"
				>

				  {/* Small Label */}
				  <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-green-200 bg-white px-4 py-2 shadow-sm">
					<span className="h-2 w-2 animate-pulse rounded-full bg-green-600" />
					<span className="text-xs font-semibold uppercase tracking-[0.2em] text-green-700">
					  University Updates
					</span>
				  </div>

				  {/* Title */}
				  <h2 className="text-3xl font-extrabold tracking-tight text-green-900 sm:text-4xl lg:text-5xl">
					Latest News
					<span className="text-green-600"> & Events</span>
				  </h2>

				  {/* Description */}
				  <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-gray-600 sm:text-base">
					Stay updated with the latest news, announcements, and events
					happening at Bandarban University.
				  </p>

				  {/* Decorative Line */}
				  <div className="mx-auto mt-6 flex items-center justify-center gap-2">
					<span className="h-1 w-12 rounded-full bg-green-300" />
					<span className="h-1.5 w-20 rounded-full bg-green-600" />
					<span className="h-1 w-12 rounded-full bg-green-300" />
				  </div>

				</motion.div>


				{/* News Carousel Wrapper */}
				<div className="relative">

				  {/* Navigation Buttons */}
				  <div className="absolute -top-20 right-0 z-20 hidden items-center gap-2 sm:flex">

					<button
					  type="button"
					  onClick={handlePrev}
					  disabled={news.length <= VISIBLE_NEWS}
					  aria-label="Previous news"
					  className="group flex h-11 w-11 items-center justify-center rounded-full border border-green-200 bg-white text-green-700 shadow-sm transition-all duration-300 hover:border-green-600 hover:bg-green-600 hover:text-white hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-40"
					>
					  <ChevronLeft
						size={21}
						className="transition-transform duration-300 group-hover:-translate-x-0.5"
					  />
					</button>

					<button
					  type="button"
					  onClick={handleNext}
					  disabled={news.length <= VISIBLE_NEWS}
					  aria-label="Next news"
					  className="group flex h-11 w-11 items-center justify-center rounded-full border border-green-200 bg-white text-green-700 shadow-sm transition-all duration-300 hover:border-green-600 hover:bg-green-600 hover:text-white hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-40"
					>
					  <ChevronRight
						size={21}
						className="transition-transform duration-300 group-hover:translate-x-0.5"
					  />
					</button>

				  </div>


				  {/* Mobile Navigation */}
				  <div className="mb-6 flex justify-end gap-2 sm:hidden">

					<button
					  type="button"
					  onClick={handlePrev}
					  disabled={news.length <= VISIBLE_NEWS}
					  aria-label="Previous news"
					  className="flex h-10 w-10 items-center justify-center rounded-full bg-green-600 text-white shadow-md transition hover:bg-green-700 disabled:opacity-40"
					>
					  <ChevronLeft size={20} />
					</button>

					<button
					  type="button"
					  onClick={handleNext}
					  disabled={news.length <= VISIBLE_NEWS}
					  aria-label="Next news"
					  className="flex h-10 w-10 items-center justify-center rounded-full bg-green-600 text-white shadow-md transition hover:bg-green-700 disabled:opacity-40"
					>
					  <ChevronRight size={20} />
					</button>

				  </div>


				  {/* Animated News Grid */}
				  <AnimatePresence mode="wait" initial={false}>

					<motion.div
					  key={indexs}
					  initial={{ opacity: 0, x: 45 }}
					  animate={{ opacity: 1, x: 0 }}
					  exit={{ opacity: 0, x: -45 }}
					  transition={{
						duration: 0.55,
						ease: [0.22, 1, 0.36, 1],
					  }}
					  className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4"
					>

					  {currentNews.map((newsdata, i) => (

						<motion.article
						  key={`${newsdata.id}-${indexs}-${i}`}
						  initial={{ opacity: 0, y: 20 }}
						  animate={{ opacity: 1, y: 0 }}
						  transition={{
							duration: 0.45,
							delay: i * 0.08,
							ease: "easeOut",
						  }}
						  whileHover={{ y: -8 }}
						  className="group flex h-full flex-col overflow-hidden rounded-3xl border border-green-100/80 bg-white shadow-[0_8px_30px_rgba(22,101,52,0.07)] transition-shadow duration-500 hover:shadow-[0_18px_45px_rgba(22,101,52,0.16)]"
						>

						  {/* Image */}
						  <div className="relative h-52 overflow-hidden bg-green-100">

							<img
							  src={`${import.meta.env.VITE_API_SOURCE_URL}${newsdata.images_path}`}
							  alt={newsdata.head_line}
							  loading="lazy"
							  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
							/>

							{/* Image Gradient */}
							<div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-70" />

							{/* Top Badge */}
							<div className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-white/95 px-3 py-1.5 text-xs font-semibold text-green-800 shadow-sm backdrop-blur-sm">
							  <CalendarDays size={13} />
							  News
							</div>

							{/* Hover Icon */}
							<div className="absolute right-4 top-4 flex h-9 w-9 translate-y-2 items-center justify-center rounded-full bg-white/90 text-green-700 opacity-0 shadow-md transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
							  <ArrowUpRight size={17} />
							</div>

						  </div>


						  {/* Content */}
						  <div className="flex flex-1 flex-col p-5 sm:p-6">

							{/* Date */}
							<div className="mb-3 flex items-center gap-2 text-xs font-medium text-gray-500">

							  <CalendarDays size={14} className="text-green-600" />

							  <span>
								{newsdata.date?.split("-")[2]}{" "}
								{MonthDisplay(newsdata.date)}{" "}
								{newsdata.date?.split("-")[0]}
							  </span>

							</div>


							{/* Title */}
							<h3 className="line-clamp-3 min-h-[4.5rem] text-lg font-bold leading-7 text-gray-800 transition-colors duration-300 group-hover:text-green-700">
							  {newsdata.head_line}
							</h3>


							{/* Divider */}
							<div className="my-5 h-px bg-gradient-to-r from-green-100 via-green-200 to-transparent" />


							{/* Details Button */}
							<div className="mt-auto">

							  <Link
								to={`/news/${newsdata.id}`}
								className="group/btn inline-flex items-center gap-2 rounded-xl bg-green-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-all duration-300 hover:bg-green-700 hover:shadow-lg"
							  >
								Read Details

								<ArrowUpRight
								  size={16}
								  className="transition-transform duration-300 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5"
								/>
							  </Link>

							</div>

						  </div>

						</motion.article>

					  ))}

					</motion.div>

				  </AnimatePresence>


				  {/* Bottom Progress Indicators */}
				  {news.length > VISIBLE_NEWS && (

					<div className="mt-10 flex items-center justify-center gap-2">

					  {news.map((item, i) => (

						<button
						  key={item.id}
						  type="button"
						  aria-label={`Go to news ${i + 1}`}
						  onClick={() => setIndexs(i)}
						  className={`h-2 rounded-full transition-all duration-500 ${
							i === indexs
							  ? "w-8 bg-green-600"
							  : "w-2 bg-green-200 hover:bg-green-400"
						  }`}
						/>

					  ))}

					</div>

				  )}

				</div>

			  </div>

			</section>
			<section className="w-full bg-gradient-to-r from-green-50 to-white py-16 px-6 md:px-20">
			  <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-start">
				{/* Left Side - Main Video */}
				<div className="w-full">
				  {selectedVideo ? (
					<>
					  <div className="aspect-video rounded-xl overflow-hidden shadow-lg">
						<iframe
						  className="w-full h-full"
						  src={`https://www.youtube.com/embed/${selectedVideo.video_id}?rel=0&autoplay=${
							autoPlay ? 1 : 0
						  }`}
						  title={selectedVideo.title}
						  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						  allowFullScreen
						></iframe>
					  </div>
					  <h3 className="mt-4 text-xl font-semibold text-green-800">
						{selectedVideo.title}
					  </h3>
					</>
				  ) : (
					<p className="text-gray-600">Loading video...</p>
				  )}
				</div>

				{/* Right Side - Recent Videos */}
				<div className="space-y-4">
				  <h2 className="text-2xl font-bold text-green-800 mb-4">Recent Videos</h2>
				  {videos.slice(0, 5).map((video) => (
					<div
					  key={video.id}
					  onClick={() => handleVideoClick(video)}
					  className={`flex items-center gap-4 p-3 rounded-lg cursor-pointer transition ${
						selectedVideo?.id === video.id
						  ? "bg-green-100"
						  : "hover:bg-green-50"
					  }`}
					>
					  <img
						src={
						  video.thumbnail ||
						  `https://img.youtube.com/vi/${video.video_id}/hqdefault.jpg`
						}
						alt={video.title}
						className="w-28 h-16 rounded-lg object-cover"
					  />
					  <p className="text-gray-800 font-medium">{video.title}</p>
					</div>
				  ))}
				</div>
			  </div>
			</section>
			<section className="w-full bg-gradient-to-b from-green-50 to-white py-16 px-6 md:px-20">
			  <div className="max-w-4xl mx-auto text-center mb-12">
				<h2 className="text-3xl md:text-4xl font-bold text-green-800">
				  Frequently Asked Questions
				</h2>
				<p className="text-gray-600 mt-2">
				  Find quick answers to some of the most common queries
				</p>
			  </div>

			  <div className="max-w-4xl mx-auto space-y-4">
				{faqs.map((faq) => (
				  <div
					key={faq.id}
					className="bg-white rounded-xl shadow-md hover:shadow-lg transition border border-green-100"
				  >
					<button
					  onClick={() => toggleFAQ(faq.id)}
					  className="w-full flex justify-between items-center px-6 py-4 text-left"
					>
					  <span className="font-medium text-green-800">{faq.question}</span>
					  <ChevronDown
						className={`w-5 h-5 text-green-600 transition-transform ${
						  openId === faq.id ? "rotate-180" : ""
						}`}
					  />
					</button>

					<AnimatePresence>
					  {openId === faq.id && (
						<motion.div
						  initial={{ height: 0, opacity: 0 }}
						  animate={{ height: "auto", opacity: 1 }}
						  exit={{ height: 0, opacity: 0 }}
						  transition={{ duration: 0.3 }}
						>
						  <div className="px-6 pb-4 text-gray-600 leading-relaxed">
							{faq.answer}
						  </div>
						</motion.div>
					  )}
					</AnimatePresence>
				  </div>
				))}
			  </div>
			</section>
		</>
	  );
}
export default HomePage;